import { Button, ButtonDropdown } from '@amzn/awsui-components-react/polaris';
import * as React from 'react';
import styled from 'react-emotion';
const pageHeader = ({ title, subtitle, description, rightJustifiedDescription, buttons, rawButtons, extraContent, tag = 'h1', }) => {
    const InlineTitle = styled(tag) `
    display: inline-block;
  `;
    if (buttons && rawButtons) {
        console.info("You should use either the 'buttons' or 'rawButtons' parameter, not both");
    }
    return (React.createElement("div", { className: tag === 'h1' ? 'awsui-util-mb-m awsui-util-mt-xs' : undefined },
        React.createElement("div", { className: tag === 'h1' ? 'awsui-util-action-stripe-large ' : 'awsui-util-action-stripe' },
            React.createElement("div", { className: "awsui-util-action-stripe-title" },
                React.createElement("span", null,
                    React.createElement(InlineTitle, null, title),
                    extraContent,
                    subtitle && React.createElement("div", null, subtitle),
                    description && (React.createElement("div", { className: "awsui-util-container-header-description" }, description)))),
            React.createElement("div", { className: "awsui-util-action-stripe-group awsui-util-pv-n" },
                buttons &&
                    buttons
                        .filter(b => b)
                        .map(b => b)
                        .map(({ items, id, href, text, disabled, loading, icon, variant = 'normal', onItemClick, onClick, }, key) => {
                        return !items ? (React.createElement(Button, { id: id, href: href, text: text, disabled: disabled || false, loading: loading || false, icon: icon, variant: variant, key: key, onClick: onClick })) : (React.createElement(ButtonDropdown, { id: id, text: text, disabled: disabled || false, loading: loading || false, items: items, key: key, onItemClick: onItemClick }));
                    }),
                rawButtons)),
        rightJustifiedDescription && (React.createElement("div", { id: "container-right-justified-description", className: "awsui-util-container-header-description", css: "text-align:right;" }, rightJustifiedDescription))));
};
pageHeader.displayName = 'PageHeader';
export default pageHeader;
//# sourceMappingURL=PageHeader.js.map